import React from 'react'
import { Link } from 'react-router-dom'
import { AfterPayInfo } from '@components/AfterPayInfo'
import { DEFAULT_CURRENCY } from '../../../../constants'
import { useTranslation } from 'react-i18next'
import FormattedPrice from '@components/FormattedPrice'

interface IProps {
  supplyLines: {
    pk: string
    url: string
    name: string
    price: number
    quantity: number
  }[]

  onClosePanel(): void

  showKitContent?: boolean
  // Number of kits added; supply line quantities are per one kit.
  quantity?: number
  sku: string
  properties: {
    id: number
    attributeName: string
    valueName: string
  }[]
}

const VariantKit: React.FC<IProps> = ({
  supplyLines,
  onClosePanel,
  showKitContent = true,
  quantity = 1,
  sku,
  properties,
}) => {
  const { t } = useTranslation()
  let totalPrice = 0
  supplyLines.forEach(line => {
    totalPrice += line.price * line.quantity
  })
  totalPrice *= quantity
  return (
    <div>
      <div className='font-bold mt-5 text-13'>
        <FormattedPrice currency={DEFAULT_CURRENCY} amount={totalPrice} />
      </div>
      <div className='text-13'>
        <AfterPayInfo minPrice={totalPrice} maxPrice={totalPrice} currency={DEFAULT_CURRENCY} />
      </div>
      <div className='line-clamp-2'>
        <span className='font-semibold'>{t('sku', 'SKU')}: </span>
        <span>{sku}</span>
      </div>
      <div>
        {properties.map(prop => {
          return (
            <div key={prop.id}>
              <span className='font-semibold'>{prop.attributeName}: </span>
              <span>{prop.valueName}</span>
            </div>
          )
        })}
      </div>
      <div>
        <span className='font-semibold'>{t('quantity', 'Quantity')}: </span>
        <span>{quantity}</span>
      </div>
      {showKitContent && (
        <>
          <div className='font-bold mt-5'>{t('kitsContent', "KIT's CONTENT")}</div>
          {supplyLines.map((line, i) => {
            return (
              <div key={line.pk}>
                <span>{i + 1}. </span>
                <Link to={line.url} onClick={onClosePanel}>
                  {line.name}{' '}
                </Link>
                <span>
                  {t('xQtyPcs', { defaultValue: 'x {{quantity}}pcs', quantity: line.quantity })} -{' '}
                  <FormattedPrice currency={DEFAULT_CURRENCY} amount={line.price} />
                </span>
              </div>
            )
          })}
        </>
      )}
    </div>
  )
}

export default VariantKit
